
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M5.75 12a6.25 6.25 0 1112.5 0 6.25 6.25 0 01-12.5 0zM12 4.25a7.75 7.75 0 100 15.5 7.75 7.75 0 000-15.5zm-1.803 4.886a.75.75 0 00-1.06 1.061L10.938 12l-1.803 1.803a.75.75 0 001.061 1.06L12 13.062l1.803 1.803a.75.75 0 001.06-1.061L13.062 12l1.803-1.803a.75.75 0 00-1.061-1.06L12 10.938l-1.803-1.803z"}})])
          )
        }
      }
    